import cameronImg from '@/assets/images/splash/chat-person-1.png';
import dianneImg from '@/assets/images/splash/chat-person-2.png';
import eleanorImg from '@/assets/images/splash/chat-person-3.png';

import platformPolicy from '@/assets/images/splash/splash-platform-policy.png';
import platformSignature from '@/assets/images/splash/splash-platform-signature.png';
import platformStaff from '@/assets/images/splash/splash-platform-staff.png';
import platformCertificate from '@/assets/images/splash/splash-platform-certificate.png';
import platformCabinet from '@/assets/images/splash/splash-platform-cabinet.png';
import platformChat from '@/assets/images/splash/splash-platform-chat.png';

export const chatData = [
  {
    avatar: cameronImg,
    name: 'Cameron Williamson',
    title: 'Casco Bay Dental',
    message: 'How can I avoid paying unemployment?',
  },
  {
    avatar: dianneImg,
    name: 'Dianne Russell',
    title: 'Carpet Caretakers, LLC',
    message: 'Can I terminate someone with a disability?',
  },
  {
    avatar: eleanorImg,
    name: 'Eleanor Pena',
    title: 'Waba Grill',
    message: 'What is the EEOC?',
  },
];

export const employeeChatData = [
  {
    avatar: cameronImg,
    name: 'Cameron W.',
    title: 'Casco Bay Dental',
    message: 'How can I avoid paying unemployment?',
  },
  {
    avatar: dianneImg,
    name: 'Dianne R.',
    title: 'Carpet Caretakers, LLC',
    message: 'Can I terminate someone with a disability?',
  },
  {
    avatar: eleanorImg,
    name: 'Eleanor P.',
    title: 'Waba Grill',
    message: 'What is the EEOC?',
  },
  {
    avatar: cameronImg,
    name: 'Cameron W.',
    title: 'Casco Bay Dental',
    message: 'How can I avoid paying unemployment?',
  },
];

export const hrMaterials = [
  'offer letter',
  'sick leave policy',
  'non-disclosure agreement',
  'HIPAA notice',
  'non-solicitation agreement',
  'discrimination & harassment policy',
  'notice to employee',
  'non-compete agreement',
  'dress code policy',
  'meal & break policy',
  'absenteeism and tardiness policy',
  'smoking policy',
  'PTO policy',
  'social media policy',
  'independent contractor agreement',
  'pet policy',
  'gift policy',
  'bereavement policy',
  'remote work policy',
  'fraternization policy',
  'substance abuse policy',
];

export const features = [
  {
    image: platformPolicy,
    title: 'Create, Implement, and Manage Company Policy',
    text: "From sexual harassment & non-discrimination to PTO and sick leave, we'll help you create and implement HR policy across your business.",
  },
  {
    image: platformSignature,
    title: 'E-Signatures for Important Documents',
    text: 'Invite your staff to join Bambee where they can set up folders, see memos, and view & sign important documents using our securee-signature technology.',
  },
  {
    image: platformStaff,
    title: 'Staff Folders for Internal Compliance and Organization',
    text: 'Staff folders ensure the right files are accessible, compliant, and signed with everyone on your staff.',
  },
  {
    image: platformCertificate,
    title:
      'Staff Training for a Better, Safer, More Compliant working environment',
    text: 'Many workplace conflicts can be prevented with proper training and education. Your HRM will customize recommendations to tailor trainings to your business needs. With over 650 courses, Bambee can provide you with the tools to create a better working environment.',
  },
  {
    image: platformCabinet,
    title: 'Smart Cabinet for Record Keeping',
    text: 'Federal & State laws mandate that certain company files be held for a certain period of time. Bambee Tools help meet retention needs.',
  },
  {
    image: platformChat,
    title: 'Unlimited Direct Chat With Your HR Manager',
    text: 'Business owners can contact their HR manager during business hours by phone, email, or direct chat.',
  },
];
